import React from 'react'
import AppContainer from '../../Components/Structure/AppContainer';
import { Link } from 'react-router-dom';
import toast, {Toaster} from "react-hot-toast";

const SettingsPage = props => {

    const pageUpdate = (e) => {
        e.preventDefault()
        toast.error("Update Page is under construction!", {duration: 5000});
    }
  
    return (
        <AppContainer title={"Settings"} >
            <Toaster position="top-right" reverseOrder={false} />
            <div class="row gutters-20">
                <div class="col-lg-4 col-sm-6 col-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <Link to="/districts">
                            <div className="box-body" style={{position:"relative"}}>
                                <div className="user-pic text-center" >
                                    <div class="main-profile-overview widget-user-image text-center">
							            <div class="main-img-user">
                                            <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/map-point.png"}/>
                                        </div>
						            </div>
                                    <div className="pro-user mt-3" style={{marginTop: "1rem !important"}}>
                                        <h5 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>Districts</h5>
                                        <h6 className="pro-user-desc text-muted fs-14">Add or register new district</h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6 col-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <Link to="/regions">
                            <div className="box-body" style={{position:"relative"}}>
                                <div className="user-pic text-center" >
                                    <div class="main-profile-overview widget-user-image text-center">
							            <div class="main-img-user">
                                            <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/colombia.png"}/>
                                        </div>
						            </div>
                                    <div className="pro-user mt-3" style={{marginTop: "1rem !important"}}>
                                        <h5 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>Regions</h5>
                                        <h6 className="pro-user-desc text-muted fs-14">Add or create new region</h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6 col-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <Link to="/rates">
                            <div className="box-body" style={{position:"relative"}}>
                                <div className="user-pic text-center" >
                                    <div class="main-profile-overview widget-user-image text-center">
							            <div class="main-img-user">
                                            <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/interest.png"}/>
                                        </div>
						            </div>
                                    <div className="pro-user mt-3" style={{marginTop: "1rem !important"}}>
                                        <h5 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>Charge Rates</h5>
                                        <h6 className="pro-user-desc text-muted fs-14">Add or update the sms and call rates</h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <Link to="/communication-settings">
                            <div className="box-body" style={{position:"relative"}}>
                                <div className="user-pic text-center" >
                                    <div class="main-profile-overview widget-user-image text-center">
							            <div class="main-img-user">
                                            <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/setting.png"} style={{height:"80px"}}/>
                                        </div>
						            </div>
                                    <div className="pro-user mt-3" style={{marginTop: "1rem !important"}}>
                                        <h5 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>Communication Settings</h5>
                                        <h6 className="pro-user-desc text-muted fs-14">Enable or disable calls and messages</h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <Link to="/pocket-money-settings">
                            <div className="box-body" style={{position:"relative"}}>
                                <div className="user-pic text-center" >
                                    <div class="main-profile-overview widget-user-image text-center">
							            <div class="main-img-user">
                                            <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/control.png"} style={{height:"80px"}}/>
                                        </div>
						            </div>
                                    <div className="pro-user mt-3" style={{marginTop: "1rem !important"}}>
                                        <h5 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>Pocket Money Settings</h5>
                                        <h6 className="pro-user-desc text-muted fs-14">Enable or disable pocket money transactions</h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <Link to="/authentication-settings">
                            <div className="box-body" style={{position:"relative"}}>
                                <div className="user-pic text-center" >
                                    <div class="main-profile-overview widget-user-image text-center">
							            <div class="main-img-user">
                                            <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/phone-booth.png"} style={{height:"80px"}}/>
                                        </div>
						            </div>
                                    <div className="pro-user mt-3" style={{marginTop: "1rem !important"}}>
                                        <h5 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>Booth Authentication Settings</h5>
                                        <h6 className="pro-user-desc text-muted fs-14">Enable or disable booth authentication methods</h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6 col-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <Link to="/school-terms">
                            <div className="box-body" style={{position:"relative"}}>
                                <div className="user-pic text-center" >
                                    <div class="main-profile-overview widget-user-image text-center">
							            <div class="main-img-user">
                                            <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/school.png"} style={{height:"80px"}}/>
                                        </div>
						            </div>
                                    <div className="pro-user mt-3" style={{marginTop: "1rem !important"}}>
                                        <h5 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>School Terms</h5>
                                        <h6 className="pro-user-desc text-muted fs-14">Add or manage school terms</h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6 col-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <Link 
                        // to="/app-update" 
                        onClick={(e) => pageUpdate(e)}>
                            <div className="box-body" style={{position:"relative"}}>
                                <div className="user-pic text-center" >
                                    <div class="main-profile-overview widget-user-image text-center">
							            <div class="main-img-user">
                                            <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/update.png"} style={{height:"80px"}}/>
                                        </div>
						            </div>
                                    <div className="pro-user mt-3" style={{marginTop: "1rem !important"}}>
                                        <h5 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>Update Page</h5>
                                        <h6 className="pro-user-desc text-muted fs-14">Add text to be displayed on the update page</h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
                
            </div>

        </AppContainer>
    )
}

export default SettingsPage;